export default {
  daily: 'Day',
  monthly: 'Month',
  yearly: 'Annual',
  quarterly: 'Quarter',
};
